@let resultValue = result();
<span [ngClass]="resultValue.colorClass">{{ resultValue.value | resolveTranslateAbleText }}</span>
